export default __webpack_public_path__ + "static/media/Alaska-Airlines-Logo-w.ba303ca3.png";